import api from '../../../utils/api';
import { EventsPathType } from './enums';

export default class EventsApiService {
  static bookViewing(request) {
    return api.post(
      `${EventsPathType.Root}/showings`,
      request,
    );
  }
}
